const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`dn h60 w270 ttU usN tdN ph15 lts0em bgF b1 bs
        layoutRow fhaC fvaC lh fw4 f16 ov dn
        (bc|c)5B47FF
        o70:not[.disabled]:h
        (bc|c)A3A7AC.disabled
        cC>.MuiButtonBase-root ` + (props.className || '')
      }
    />
  );
};
